
import { create } from "zustand";
import axios from "axios";
import { API_BASE_URL1, API_BASE_URL3 } from "../../../Services/baseApiUrl";
import { apiCall } from "../../../../utils/apiCall";
import { toast } from "react-toastify";

const RouteSummaryPathStore = create((set, get) => ({

    routeSummaryPathData: [],
    driverData: [],
    loading: false,
    error: false,

    fetchRouteSummaryPathMasters: async (routeFilter, vehicleFilter) => {
        set({ loading: true, error: null });
        try {
            let url = `${API_BASE_URL1}Routes/GetAllRoutesWithPointNames`;
            const params = [];
            
            if (routeFilter) {
                params.push(`RouteFilter=${routeFilter}`);
            }
            if (vehicleFilter) {
                params.push(`VehicleNumber=${vehicleFilter}`);
            }
            
            if (params.length > 0) {
                url += `?${params.join('&')}`;
            }

            const routeSummaryData = await apiCall({
                url,
                method: "get",
                token: localStorage.getItem("token"),
            });
            set({
                routeSummaryPathData: Array.isArray(routeSummaryData) ? routeSummaryData : [],
                loading: false
            });

        } catch (error) {
            console.log(error.response?.data?.message || "Error fetching data");
            if (error.response && error.response.status === 404) {
                set({
                    routeSummaryPathData: [], // fixed typo: routeSummaryPathData → routeSummaryPathData
                    error: "No route masters found.",
                    loading: false
                });
            } else {
                set({ error: error.response?.data?.message || "Something went wrong", loading: false });
            }
        }
    },

    fetchDriverByVehicleId: async (vehicleId) => {
        set({ loading: true, error: null });
        try {
            const url = `${API_BASE_URL1}Routes/GetDriverByVehicleId?vehicleId=${vehicleId}`;

            const driverData = await apiCall({
                url,
                method: "get",
                token: localStorage.getItem("token"),
            });
            set({
                driverData: Array.isArray(driverData.drivers) ? driverData.drivers : [],
                loading: false
            });

        } catch (error) {
            console.log(error.response?.data?.message || "Error fetching driver data");
            if (error.response && error.response.status === 404) {
                set({
                    driverData: [],
                    error: "No driver found for this vehicle.",
                    loading: false
                });
            } else {
                set({ error: error.response?.data?.message || "Something went wrong", loading: false });
            }
        }
    },

    clearDriverData: () => {
        set({ driverData: [] });
    },

    updateRouteSummaryPathData: async (existingrouteSummaryPathData) => {
        set({ loading: true, error: null });
        try {
            const response = await axios.put(
                `${API_BASE_URL1}Routes/UpdateRouteStatus`,
                existingrouteSummaryPathData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            set((state) => ({
                routeSummaryPathData: [...state.routeSummaryPathData, response],
                loading: false
            }));
            toast.success(response.data.message);
            return { success: true };

        } catch (error) {
            console.error("Error adding Route Master:", error.response?.data || error.message);

            if (error.response?.status === 400) { // Handle validation errors
                const validationErrors = error.response.data.errors || error.response.data;

                if (typeof validationErrors === "object") {
                    let errorMessages = [];

                    Object.keys(validationErrors).forEach((key) => {
                        if (Array.isArray(validationErrors[key])) {
                            validationErrors[key].forEach((msg) => {
                                errorMessages.push(msg);
                            });
                        } else {
                            errorMessages.push(validationErrors[key]);
                        }
                    });

                    errorMessages.forEach((msg) => toast.error(msg));
                    return { success: false, errors: validationErrors };
                }
            }

            // Handle general errors
            const errorMessage = error.response?.data || "Failed to add Route Master";
            toast.error(errorMessage);
            set({ error: errorMessage, loading: false });

            return { success: false, errors: { general: errorMessage } };
        }
        finally {
            set({ loading: false });
        }
    },


}))

export default RouteSummaryPathStore